import clsx from 'clsx'

import { CheckBoxSimple } from 'shared/ui/check-box-simple'

import s from './styles.module.scss'

interface Props {
  name?: string | React.ReactNode
  isActive?: boolean
  onClick?: (isActive?: boolean) => void
  className?: string
}

export const ResortTypeCard = ({
  name,
  isActive,
  onClick,
  className,
}: Props) => {
  return (
    <div
      onClick={() => onClick?.(!isActive)}
      className={clsx(s.resortTypeCard, className)}
    >
      <div className={clsx('medium-16', s.resortTypeName)}>{name}</div>

      <CheckBoxSimple
        isBigSize
        isChecked={isActive}
      />
    </div>
  )
}
